export default __webpack_public_path__ + "static/media/icon_check_circle_24_Regular.1d8b7aef.svg";